<template>
	<div v-if="booted" id="content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<h5>{{ $t('horse.text_rechercher_bis') }}</h5>
				</div>
				<div class="col-12">
					<div class="d-md-flex align-items-center">
						<div class="flex-grow-1 mb-1">
							<div class="input-group">
								<div v-if="all_types_search.length > 1" class="input-group-prepend">
									<e-select
									track-by="code"
									label="label"
									:options="all_types_search"
									:allow-empty="false"
									:show-labels="false"
									v-model="type_search"
									/>
								</div>
								<input type="text" class="form-control" v-model="search_value" @keydown.enter.prevent="search" required :placeholder="$t('horse.placeholder_'+type_search.code)">
							</div>
						</div>
						<div class="d-flex align-items-center mb-1 flex-shrink-0">
							<b-button class="text-nowrap btn-sm ml-2" variant="primary" @click="search">{{ $t('global.rechercher') }} <font-awesome-icon v-if="searching" :icon="['fas', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'search']" class="ml-2" /></b-button>
						</div>
					</div>
				</div>
				<div class="col-12 d-none d-md-flex justify-content-center">
					<template v-for="(filter, index) in filters_saved">
						<b-button v-if="is_not_empty(filter)" @click="deleteFilter(index)" :key="index" variant="outline-secondary" rounded pill size="sm" class="mt-1 mr-2 md-mb-3 mb-1 d-md-flex d-inline-block text-nowrap flex-shrink-0 align-items-center btn-xs">
							{{ $t('horse.filter.'+index) }} : 
							<template v-if="index == 'race'">
								{{ race_formatted }}
							</template>
							<template v-else-if="index == 'sexe'">
								{{ filter.sexe_label }}
							</template>
							<template v-else-if="index == 'alive'">
								{{ $t('global.oui') }}
							</template>
							<template v-else>
								{{ filter }}
							</template>
							<font-awesome-icon class="ml-2" :icon="['fal', 'times']" />
						</b-button>
					</template>
				</div>
				<LoadingSpinner v-if="processing" class="col-12"/>
				<template v-else-if="type_search && type_search.code == 'ifce'">
					<div v-if="horses.length > 0" class="col-12 mt-2">
						<div v-for="horse in horses" :key="horse.references.idPub" class="result_horse" @click="addHorseSire(horse)">
							<div class="row align-items-center">
								<div class="col-12 col-md">
									<h5 class="mb-0">{{ horse.nom }} <small>({{ horse.sire }}{{ horse.key }})</small></h5>
									{{ horse.genealogy.sireName }} {{ $t('horse.et') }} {{ horse.genealogy.damName }}<br>
									{{ horse.codeRace }}, {{ horse.codeSexe }}, {{ horse.codeRobe }}, {{ horse.yearNaissance }}<br>
								</div>
								<div class="col-12 col-md-auto mt-2 mt-md-0">
									<b-button variant="secondary" block>{{ $t('global.ajouter') }}</b-button>
								</div>
							</div>
						</div>
					</div>
					<div v-if="show_buttons" class="col-12 row mt-2">
						<div class="col-12 text-center">
							<b>{{ $t('horse.dont_find') }}</b>
						</div>
						<div class="col-12 text-center">
							<div class="d-inline-flex justify-content-center">
								<b-button variant="primary" @click="skip">{{ $t('horse.skip_etape') }}</b-button>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
import Horse from "@/mixins/Horse.js"
import UserMixin from "@/mixins/User.js"
import _deepClone from 'lodash/cloneDeep'
import _isEmpty from 'lodash/isEmpty'

export default {
	name: 'HorseAjout',
	mixins: [Horse, UserMixin],
	props: ['horse_sexe', 'horse_name', 'close', 'horse_selected'],
	data () {
		return {
			search_value: '',
			all_types_search: [],
			type_search: null,
			code_erreur: '',
			booted: false,
			searching: false,
			processing: false,
			horses: [],
			filters_ifce: {
				date_min: null,
				date_max: null,
				mother_name: null,
				father_name: null,
				race: [],
				sexe: null,
				alive: null
			},
			filters_saved: {},
			horse_sexes: [],
			horse_races: [],
			horse_robes: [],
			licence_horses: [],
			show_buttons: false,
		}
	},
	
	mounted() {
		this.init_component()
	},
	
	methods: {
		async init_component() {
			this.all_types_search.push({
				code: 'ifce',
				label: 'IFCE'
			})
			this.type_search = this.all_types_search[0]
			
			this.horse_sexes = await this.getSexes()
			this.horse_races = await this.getRaces()
			this.horse_sexes.push({
				sexe_code: 'MH',
				sexe_label: this.getTrad('horse.male_hongre')
			})
			this.horse_robes = await this.getRobes()
			if(this.horse_sexe == 'F') {
				this.filters_ifce.sexe = this.horse_sexes.find(sex => sex.sexe_code == 'F')
			}
			if(this.horse_sexe == 'M') {
				this.filters_ifce.sexe = this.horse_sexes.find(sex => sex.sexe_code == 'MH')
			}
			const date = new Date()
			this.filters_ifce.date_min = date.getFullYear() - 40
			this.filters_ifce.date_max = date.getFullYear() - 5
			
			this.filters_saved = _deepClone(this.filters_ifce)
			
			if(this.horse_name) {
				this.search_value = this.horse_name
				this.search()
			}
			
			this.booted = true
		},
		
		search() {
			this.show_buttons = false
			this.searching = true
			this.horses = []
			const input = this.clean_input(this.search_value)
			this['search_'+this.type_search.code](input)
		},
		
		async search_ifce(input) {
			// On commence par tester les regex d'erreurs possibles
			this.code_erreur = this.checkPotentialError(input)
			if(this.code_erreur == '') {
				let horse_id = null
				let exists = false
				if(this.regex_sire.test(input)) {
					const data = await this.addHorse(input, 'sire', null, 0)
					if(!data.code) {
						this.sendHorse(data)
					}
				}
				else if(this.regex_microship.test(input)) {
					const data = await this.addHorse(input, 'microship', null, 0)
					if(!data.code) {
						this.sendHorse(data)
					}
				}
				else if(this.regex_ueln.test(input)) {
					const data = await this.addHorse(input, 'ueln', null, 0)
					if(!data.code) {
						this.sendHorse(data)
					}
				}
				else if(this.regex_name_like.test(input)) {
					let filters = _deepClone(this.filters_saved)
					if(!_isEmpty(filters)) {
						if(filters.race && (filters.race.length > 1 || filters.race.length == 0)) {
							filters.race = null
						}
						else if(filters.race && filters.race.length == 1) {
							filters.race = filters.race[0]
						}
						
						if(filters.sexe && filters.sexe.sexe_code == 'MH') {
							filters.sexe = null
						}
					}
					
					const data = await this.fetchHorseByNameIfce(input, filters)
					this.show_buttons = true
					if(data.code == 0) {
						let horses = data.result
						if(!_isEmpty(this.filters_saved)) {
							if(this.filters_saved.alive) {
								horses = horses.filter(horse => !horse.dateMort)
							}
							
							if(this.filters_saved.race && this.filters_saved.race.length > 1) {
								const races_code = this.filters_saved.race.map(race => race.race_code)
								horses = horses.filter(horse => races_code.includes(horse.codeRace))
							}
							
							if(this.filters_saved.sexe && this.filters_saved.sexe.sexe_code == 'MH') {
								horses = horses.filter(horse => horse.codeSexe == 'M' || horse.codeSexe == 'H')
							}
						}
						this.horses = horses.map(horse => {
							let year = ''
							if(horse.dateNaissance) {
								const naissance = new Date(horse.dateNaissance)
								year = naissance.getFullYear()
							}
							let race = this.horse_races.find(race => race.race_code == horse.codeRace)
							race = race ? race.race_label : horse.codeRace
							
							let sexe = this.horse_sexes.find(sexe => sexe.sexe_code == horse.codeSexe)
							sexe = sexe ? sexe.sexe_label : horse.codeSexe
							
							let robe = this.horse_robes.find(robe => robe.robe_code == horse.codeRobe)
							robe = robe ? robe.robe_label : horse.codeRobe
							
							return {...horse, yearNaissance: year, codeRace: race, codeSexe: sexe, codeRobe: robe, sireNumber: horse.references.sireNumber}
						})
					}
					else {
						this.code_erreur = data.code
					}
				}
				if(exists && horse_id) {
					this.infoToast("toast.horse_already_exists")
				}
			}
			this.searching = false
		},
		
		addHorseSire(horse_selected) {
			this.$emit("update:horse_selected", horse_selected)
		},
		
		sendHorse(horse) {
			let year = ''
			if(horse.birthDate) {
				const naissance = new Date(horse.birthDate)
				year = naissance.getFullYear()
			}
			let race = this.horse_races.find(race => race.race_code == horse.breedCode)
			race = race ? race.race_label : horse.codeRace
			
			let sexe = this.horse_sexes.find(sexe => sexe.sexe_code == horse.sex)
			sexe = sexe ? sexe.sexe_label : horse.codeSexe
			
			let robe = this.horse_robes.find(robe => robe.robe_code == horse.colourDetails)
			robe = robe ? robe.robe_label : horse.codeRobe
			
			this.addHorseSire({...horse, yearNaissance: year, codeRace: race, codeSexe: sexe, codeRobe: robe, nom: horse.birthName, sireNumber: horse.references.sireNumber})
		},
		
		clean_input: function(input) {
			if(!input) return input
			input = input.toUpperCase()
			input = input.replace(/[\u2018\u2019]/g, "'")
			input = input.replace(new RegExp(/[èéêë]/g),"e")
			return input
		},
		
		deleteFilter(index) {
			this.filters_saved[index] = null
			this.filters_ifce[index] = null
		},
		
		is_not_empty(filter) {
			return filter === true || typeof filter === 'number' || !_isEmpty(filter)
		},
		
		skip() {
			this.$emit("update:close", !this.close)
		}
	},
	
	computed: {
		error_message_trad() {
			if(['IK','IF','NOR'].indexOf(this.code_erreur) > -1) {
				return this.getTrad("horse.introuvable")
			}
			return this.getTrad("error."+(this.code_erreur == "" ? "UKE" : this.code_erreur))
		},
		race_formatted() {
			return this.filters_saved.race.map(race => race.race_label).join(' / ')
		}
	},
	
	components: {
		HeaderTab: () => import('@/components/HeaderTab'),
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
	}
}

</script>